import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=2feb332b&scoped=true"
import script from "./Location.vue?vue&type=script&lang=ts"
export * from "./Location.vue?vue&type=script&lang=ts"
import style0 from "./Location.vue?vue&type=style&index=0&id=2feb332b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feb332b",
  null
  
)

export default component.exports